'use strict';

import beatsCtrl from './beats-ctrl';

const MODULE_NAME = 'daupler.beats';

var app = angular.module(MODULE_NAME, [
]);
app.controller('BeatsCtrl', beatsCtrl);

export default MODULE_NAME;
